<script lang="ts">
  import { toasts, removeToast } from '../../lib/toast';
  import { fly } from 'svelte/transition';
  import { flip } from 'svelte/animate';
</script>

<div class="fixed top-4 left-1/2 transform -translate-x-1/2 z-[100] flex flex-col gap-2 w-full max-w-md px-4 pointer-events-none">
  {#each $toasts as toast (toast.id)}
    <div
      animate:flip={{ duration: 200 }}
      transition:fly={{ y: -50, duration: 200 }}
      class="pointer-events-auto flex items-center p-4 rounded-xl shadow-2xl border backdrop-blur-xl
      {toast.type === 'success' ? 'bg-emerald-900/80 border-emerald-500/50 text-emerald-100 shadow-emerald-900/20' : 
       toast.type === 'error' ? 'bg-red-900/80 border-red-500/50 text-red-100 shadow-red-900/20' : 
       'bg-indigo-900/80 border-indigo-500/50 text-indigo-100 shadow-indigo-900/20'}"
    >
      <div class="mr-3 text-xl">
        {#if toast.type === 'success'}✅{/if}
        {#if toast.type === 'error'}❌{/if}
        {#if toast.type === 'info'}ℹ️{/if}
      </div>
      <div class="flex-1 font-medium text-sm leading-tight">{toast.message}</div>
      <button 
        on:click={() => removeToast(toast.id)}
        class="ml-3 p-1 rounded-full hover:bg-white/10 transition-colors"
      >
        ✕
      </button>
    </div>
  {/each}
</div>
